import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	period: {
		id: 'servicedesk-reports-common.date-filter.date-picker-group.time-breakdown.period',
		defaultMessage: 'period',
		description: 'Input label to time breakdown dropdown',
	},
	hourly: {
		id: 'servicedesk-reports-common.date-filter.date-picker-group.time-breakdown.hourly',
		defaultMessage: 'hourly',
		description: 'Text for selecting time breakdown by hour in a dropdown',
	},
	daily: {
		id: 'servicedesk-reports-common.date-filter.date-picker-group.time-breakdown.daily',
		defaultMessage: 'daily',
		description: 'Text for selecting time breakdown by daily in a dropdown',
	},
	weekly: {
		id: 'servicedesk-reports-common.date-filter.date-picker-group.time-breakdown.weekly',
		defaultMessage: 'weekly',
		description: 'Text for selecting time breakdown by weekly in a dropdown',
	},
	monthly: {
		id: 'servicedesk-reports-common.date-filter.date-picker-group.time-breakdown.monthly',
		defaultMessage: 'monthly',
		description: 'Text for selecting time breakdown by monthly in a dropdown',
	},
});
